import { css, Theme } from '@emotion/react'
import { APP_NAME, APP_VERSION, COPYRIGHT } from '@/constants/app'

const footerStyle = (t: Theme) => css`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 24px;
  margin-top: auto;
  font-size: ${t.fs.sm};
  color: #767676;
  gap: 4px;
`

const linkStyle = css`
  color: inherit;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`

export const Footer = () => {
  return (
    <footer css={footerStyle}>
      <a href="https://corp.smaregi.jp/" target="_blank" rel="noopener noreferrer" css={linkStyle}>
        {COPYRIGHT}
      </a>
      <span>{APP_NAME} ver.{APP_VERSION}</span>
    </footer>
  )
}
